import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, isVNode, isPlainObject } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import VirtualList from '../virtual-list';
import Search from './search';
import Item from './item';
import Checkbox from '../checkbox';
var defaultLazy = {
  height: 33,
  remain: 4
};
export default {
  name: buildComponentName('TransferList'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-transfer-list'
    },
    direction: {
      type: String,
      default: 'left'
    },
    title: {
      type: String,
      default: ''
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filterOption: {
      type: Function,
      default: null
    },
    checkedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    renderContent: {
      type: Function,
      default: undefined
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ''
    },
    notFoundContent: {
      type: String,
      default: 'Not Found'
    },
    itemUnit: {
      type: String,
      default: '项'
    },
    itemsUnit: {
      type: String,
      default: '项'
    },
    lazy: {
      type: [Object, Boolean],
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      searchVal: ''
    };
  },
  computed: {
    nLazy: function nLazy() {
      var lazy = this.lazy;

      if (lazy === false) {
        return false;
      }

      if (isPlainObject(lazy)) {
        return _objectSpread({}, defaultLazy, {}, lazy);
      }

      return defaultLazy;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          nLazy = this.nLazy;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-no-lazy"), !nLazy), _ref;
    },
    filtedDataSource: function filtedDataSource() {
      var dataSource = this.dataSource,
          _this$searchVal = this.searchVal,
          searchVal = _this$searchVal === void 0 ? '' : _this$searchVal,
          searchFilter = this.searchFilter;
      var trimSearchVal = searchVal.trim();

      if (trimSearchVal) {
        return dataSource.filter(function (v) {
          return searchFilter(trimSearchVal, String(v.label || v.title || v.key), v);
        });
      }

      return dataSource;
    },
    filtedAndNoDisabledDataSource: function filtedAndNoDisabledDataSource() {
      return this.filtedDataSource.filter(function (v) {
        return !v.disabled;
      });
    },
    validCheckedKeys: function validCheckedKeys() {
      var dataSource = this.dataSource,
          checkedKeys = this.checkedKeys;
      return dataSource.filter(function (item) {
        return checkedKeys.indexOf(item.$$_key) > -1;
      }).map(function (item) {
        return item.$$_key;
      });
    },
    checkedKeysObj: function checkedKeysObj() {
      return this.checkedKeys.reduce(function (r, k) {
        var nr = r;
        nr[k] = 1;
        return nr;
      }, {});
    },
    checkBoxAllStatus: function checkBoxAllStatus() {
      var filtedAndNoDisabledDataSource = this.filtedAndNoDisabledDataSource,
          checkedKeys = this.checkedKeys,
          checkedKeysObj = this.checkedKeysObj;
      var status = 'none';

      if (checkedKeys.length === 0) {
        status = 'none';
      } else if (filtedAndNoDisabledDataSource.length > 0 && filtedAndNoDisabledDataSource.every(function (v) {
        return v.$$_key in checkedKeysObj;
      })) {
        status = 'all';
      } else if (filtedAndNoDisabledDataSource.some(function (v) {
        return v.$$_key in checkedKeysObj;
      })) {
        status = 'part';
      }

      return {
        checkAll: status === 'all',
        checkPart: status === 'part'
      };
    },
    isAllCheckDisabled: function isAllCheckDisabled() {
      var disabled = this.disabled,
          filtedAndNoDisabledDataSource = this.filtedAndNoDisabledDataSource;
      return disabled || filtedAndNoDisabledDataSource.length === 0;
    }
  },
  methods: {
    searchFilter: function searchFilter(searchVal, text, item) {
      var filterOption = this.filterOption;

      if (isFunction(filterOption)) {
        return filterOption(searchVal, item);
      }

      return isFunction(text.indexOf) && text.indexOf(searchVal) > -1;
    },
    getSlotVNodeByName: function getSlotVNodeByName(name) {
      var $props = this.$props,
          $slots = this.$slots,
          $scopedSlots = this.$scopedSlots;
      var fn = $scopedSlots[name];

      if (isFunction(fn)) {
        return fn($props);
      }

      var slotNode = $slots[name];

      if (slotNode) {
        return slotNode;
      }

      return null;
    },
    onScroll: function onScroll(e) {
      this.$emit('scroll', this.direction, e);
    },
    onSearchInput: function onSearchInput(val) {
      this.searchVal = val;
      this.$emit('search-change', this.direction, val);
    },
    onSearchClear: function onSearchClear() {
      this.searchVal = '';
      this.$emit('search-clear', this.direction);
    },
    onItemClick: function onItemClick(item) {
      var direction = this.direction,
          checkedKeysObj = this.checkedKeysObj;
      var key = item.$$_key;
      var checked = true;

      if (key in checkedKeysObj) {
        checked = false;
      }

      this.$emit('select', direction, key, checked);
    },
    onCheckAllChange: function onCheckAllChange() {
      var direction = this.direction,
          filtedAndNoDisabledDataSource = this.filtedAndNoDisabledDataSource,
          checkedKeysObj = this.checkedKeysObj,
          _this$checkBoxAllStat = this.checkBoxAllStatus,
          checkAll = _this$checkBoxAllStat.checkAll,
          checkPart = _this$checkBoxAllStat.checkPart;
      var checked = true;
      var changedDataSource;

      if (checkAll) {
        checked = false;
        changedDataSource = filtedAndNoDisabledDataSource;
      } else if (checkPart) {
        checked = true; // eslint-disable-next-line

        changedDataSource = filtedAndNoDisabledDataSource.filter(function (v) {
          return !(v.$$_key in checkedKeysObj);
        });
      } else {
        checked = true;
        changedDataSource = filtedAndNoDisabledDataSource;
      }

      this.$emit('select-all', direction, changedDataSource.map(function (v) {
        return v.$$_key;
      }), checked);
    },
    normalizeItem: function normalizeItem(item) {
      var renderContent = this.renderContent,
          direction = this.direction;
      var title = item.title,
          label = item.label;

      if (isFunction(renderContent)) {
        var content = renderContent(_objectSpread({}, item, {
          $$direction: direction
        }), direction);

        if (content) {
          if (isVNode(content)) {
            label = content;
          } else if (isPlainObject(content)) {
            title = content.title || title;
            label = content.label || label;
          } else {
            label = content;
          }
        }
      }

      return _objectSpread({}, item, {
        title: title,
        label: label
      });
    },
    renderItem: function renderItem(item) {
      var h = this.$createElement;
      var normalizeItem = this.normalizeItem,
          checkedKeysObj = this.checkedKeysObj,
          onItemClick = this.onItemClick,
          disabled = this.disabled;
      var nItem = normalizeItem(item);
      var key = nItem.$$_key;
      var props = {
        disabled: disabled,
        item: nItem,
        title: nItem.title,
        label: nItem.label,
        checked: key in checkedKeysObj
      };
      return h(Item, {
        "key": key,
        "props": _objectSpread({}, props),
        "on": _objectSpread({}, {
          click: onItemClick
        })
      });
    },
    renderItems: function renderItems() {
      var filtedDataSource = this.filtedDataSource,
          renderItem = this.renderItem;
      return filtedDataSource.map(renderItem);
    },
    renderBody: function renderBody() {
      var _listCls, _bodyCls;

      var h = this.$createElement;
      var $props = this.$props,
          $slots = this.$slots,
          bodyFn = this.$scopedSlots.body,
          prefixCls = this.prefixCls,
          disabled = this.disabled,
          nLazy = this.nLazy,
          filtedDataSource = this.filtedDataSource,
          showSearch = this.showSearch,
          searchPlaceholder = this.searchPlaceholder,
          renderItems = this.renderItems,
          notFoundContent = this.notFoundContent,
          onSearchInput = this.onSearchInput,
          onSearchClear = this.onSearchClear,
          onScroll = this.onScroll;
      var searchInput = showSearch ? h(Search, {
        "class": "".concat(prefixCls, "-body-search-wrapper"),
        "attrs": {
          "placeholder": searchPlaceholder,
          "disabled": disabled
        },
        "on": {
          "input": onSearchInput,
          "clear": onSearchClear
        }
      }) : null;
      var listCls = (_listCls = {}, _defineProperty(_listCls, "".concat(prefixCls, "-content"), true), _defineProperty(_listCls, "".concat(prefixCls, "-content-empty"), filtedDataSource.length === 0), _listCls);
      var lazyList = nLazy ? h(VirtualList, _mergeJSXProps([{}, {
        class: listCls,
        props: _objectSpread({}, nLazy, {
          size: nLazy.height,
          wtag: 'ul',
          onscroll: onScroll
        })
      }]), [renderItems()]) : h("ul", {
        "class": listCls,
        "on": {
          "scroll": onScroll
        }
      }, [renderItems()]);
      /* <transition-group name={`${prefixCls}`} tag="ul" class={listCls} on-scroll={onScroll}>
          {renderItems()}
        </transition-group>  */

      var bodyCls = (_bodyCls = {}, _defineProperty(_bodyCls, "".concat(prefixCls, "-body"), true), _defineProperty(_bodyCls, "".concat(prefixCls, "-body-with-search"), showSearch), _bodyCls);
      return isFunction(bodyFn) ? bodyFn($props) : h("div", {
        "class": bodyCls
      }, [searchInput, lazyList, h("div", {
        "class": "".concat(prefixCls, "-body-not-found")
      }, [$slots.notFoundContent || notFoundContent])]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        classes = this.classes,
        title = this.title,
        filtedDataSource = this.filtedDataSource,
        checkedKeys = this.checkedKeys,
        itemsUnit = this.itemsUnit,
        itemUnit = this.itemUnit,
        renderBody = this.renderBody,
        getSlotVNodeByName = this.getSlotVNodeByName,
        checkBoxAllStatus = this.checkBoxAllStatus,
        onCheckAllChange = this.onCheckAllChange,
        validCheckedKeys = this.validCheckedKeys,
        isAllCheckDisabled = this.isAllCheckDisabled;
    var unit = checkedKeys.length > 1 ? itemsUnit : itemUnit;
    var checkBoxAll = h(Checkbox, {
      "attrs": {
        "control": true,
        "disabled": isAllCheckDisabled,
        "checked": checkBoxAllStatus.checkAll,
        "indeterminate": checkBoxAllStatus.checkPart
      },
      "on": {
        "change": onCheckAllChange
      }
    });
    var footerNode = getSlotVNodeByName('footer');
    var footerElement = footerNode ? h("div", {
      "class": "".concat(prefixCls, "-footer")
    }, [footerNode]) : null;
    return h("div", {
      "class": [classes, _defineProperty({}, "".concat(prefixCls, "-with-footer"), !!footerElement)]
    }, [h("div", {
      "class": "".concat(prefixCls, "-header")
    }, [checkBoxAll, h("span", {
      "class": "".concat(prefixCls, "-header-selected")
    }, [h("span", [validCheckedKeys.length > 0 ? "".concat(validCheckedKeys.length, "/") : '', "".concat(filtedDataSource.length, " ").concat(unit)]), h("span", {
      "class": "".concat(prefixCls, "-header-title")
    }, [title])])]), renderBody(), footerElement]);
  }
};